import { getPathToPosition } from '../../utils/getReachablePath/index.js';
import { isSamePosition } from '@wareena/game-algorithms';
function findEscapeRoute({ agentUnit, rankedPositions, hexProperties, gameState, rules, mapHexes, agentUnits, agentUnitsInDanger, maximumRecursiveDepth = 5, agentPositionRankModifier = 0.5, }) {
    if (maximumRecursiveDepth <= 0) {
        return null;
    }
    const agentSide = agentUnit.side;
    const positionsInReach = rankedPositions.filter((rankedPosition) => {
        if (hexProperties.getDistance(rankedPosition, agentUnit.position) <=
            agentUnit.movementPoints) {
            return true;
        }
        return false;
    });
    positionsInReach.sort((a, b) => {
        return a.rank - b.rank;
    });
    const agentPositionRank = rankedPositions.find((rp) => isSamePosition(rp, agentUnit.position))?.rank ?? 50;
    for (const targetPosition of positionsInReach) {
        if (targetPosition.rank >= agentPositionRank * agentPositionRankModifier) {
            break;
        }
        const pathToPosition = getPathToPosition(agentUnit, targetPosition, hexProperties, rules, gameState.units, mapHexes);
        if (pathToPosition && pathToPosition.length) {
            return {
                agentUnit,
                targetPosition,
                pathToTargetPosition: pathToPosition,
                targetEnemy: null,
            };
        }
        else {
            //   has blocked path, but other non-candidate units can unblock
            //     unblock
            const pathToPositionBlockedByFriendlyUnits = getPathToPosition(agentUnit, targetPosition, hexProperties, rules, gameState.units, mapHexes, (unit, _position) => {
                if (unit.side === agentSide &&
                    !unit.isFatigued &&
                    !agentUnitsInDanger[unit.id]) {
                    return false;
                }
                return true;
            });
            if (pathToPositionBlockedByFriendlyUnits &&
                pathToPositionBlockedByFriendlyUnits.length) {
                // order of the units is important, first ones are those nearer to the path starting point
                const unitsOnPath = [];
                pathToPositionBlockedByFriendlyUnits.forEach((p) => {
                    const unitOnPath = agentUnits.find((u) => isSamePosition(u.position, p));
                    if (unitOnPath) {
                        unitsOnPath.push(unitOnPath);
                    }
                });
                for (const unitOnPath of unitsOnPath) {
                    const escapeOrder = findEscapeRoute({
                        agentUnit: unitOnPath,
                        rankedPositions,
                        hexProperties,
                        gameState,
                        rules,
                        mapHexes,
                        agentUnits,
                        agentUnitsInDanger,
                        maximumRecursiveDepth: maximumRecursiveDepth - 1,
                        agentPositionRankModifier: 1,
                    });
                    if (escapeOrder) {
                        return escapeOrder;
                    }
                }
            }
        }
    }
    return null;
}
export default findEscapeRoute;
